// The Daily Management Summary's labels come from the Excel sheet in shouty mixed
// case. On screen they read in sentence case, keeping the business abbreviations
// upper-case. (The email renders them the same way — management-summary.service.ts.)
// Used by the main Dashboard.

const ABBR: Record<string, string> = { pos: 'POs', "po's": "PO's", dos: 'DOs', sos: 'SOs' };
const MONTHS = 'jan|feb|mar|apr|april|may|jun|june|jul|july|aug|sep|sept|oct|october|nov|dec';

export function humanize(s: string): string {
  const out = s
    .toLowerCase()
    .replace(/\b(po's|pos|po|dos|do|sos|so|fy|grn|pgi|sis|ghpl|gst|mrp|c\/n)\b/g, (m) => ABBR[m] ?? m.toUpperCase())
    .replace(new RegExp(`\\b(${MONTHS})'?(\\d{2})?\\b`, 'g'), (_, m: string, yy?: string) =>
      m[0].toUpperCase() + m.slice(1) + (yy ? ` ${yy}` : ''))
    .replace(/\s*;\s*/g, ' · ')
    .replace(/\s+/g, ' ')
    .trim();
  return out.charAt(0).toUpperCase() + out.slice(1);
}

/** "RESPONSIBILITY : ACCOUNTS" → owner "Accounts"; any other note stays a note. */
export function parseNote(note?: string): { owner?: string; text?: string } {
  if (!note) return {};
  const m = /^responsibility\s*:\s*(.+)$/i.exec(note.trim());
  return m ? { owner: humanize(m[1]) } : { text: humanize(note) };
}

/** Section title without the sheet's "A · " letter prefix (shown separately). */
export function splitTitle(title: string): { letter?: string; name: string } {
  const m = /^([A-Z])\s*·\s*(.+)$/.exec(title);
  return m ? { letter: m[1], name: humanize(m[2]).replace(/\bin shop\b/i, 'in Shop') } : { name: humanize(title) };
}
